import TranslatedTextTemp from "./TranslatedTextTemp";

interface InputLabelProps {
  text: string | React.ReactNode;
  required?: boolean;
  name: string;
}

const InputLabel = ({ text, name, required = false }: InputLabelProps) => {
  return (
    <label
      htmlFor={name}
      className="flex text-base font-medium leading-8 text-gray-700"
    >
      <TranslatedTextTemp
        origintext={text?.toString()}
        text={`inputs.labels.${text}`}
      />{" "}
      {required && <div className="text-red-500">*</div>}
    </label>
  );
};
export default InputLabel;
